<template>
  <c-button
    px="0"
    py="4px"
    w="32px"
    h="32px"
    mx="4px"
    bg="transparent"
    color="darkGray.900"
    v-chakra="{
      ':hover': {
        bg: 'rgba(0, 140, 129, 0.3)',
        color: 'brand.900',
      },
    }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </c-button>
</template>

<script>
export default {
  name: "btn-pagination",
};
</script>

<style scoped></style>
